import moment from 'moment';
import * as Yup from 'yup';

export const validationSchema = (localizations: any) => {
    const requiredFieldMessage = localizations.form.requiredFieldMessage;
    const dateAfterMessage = localizations.form.dateAfterMessage;
    return Yup.object({
        // forwarderId: Yup.string().nullable().required(requiredFieldMessage),
        // shipperId: Yup.string().when('shipment_type', {
        //     is: (value: string) => ['DROP_AIR', 'DROP_OCEAN', 'AI', 'OI', 'INLAND', 'RAIL'].includes(value),
        //     then: Yup.string().nullable().required(requiredFieldMessage),
        //     otherwise: Yup.string().nullable()
        // }),
        // consigneeId: Yup.string().when('shipment_type', {
        //     is: (value: string) => ['DROP_AIR', 'DROP_OCEAN', 'AE', 'OE', 'INLAND', 'RAIL'].includes(value),
        //     then: Yup.string().nullable().required(requiredFieldMessage),
        //     otherwise: Yup.string().nullable()
        // }),
        // brokerId: Yup.string().when('shipment_type', {
        //     is: (value: string) => ['CUSTOMS'].includes(value),
        //     then: Yup.string().nullable().required(requiredFieldMessage),
        //     otherwise: Yup.string().nullable()
        // }),
        commodity: Yup.string().nullable().test('len', 'Max 200 characters', maxLengthValidation(200)),
        shipment_type: Yup.string().required(requiredFieldMessage),
        origin: Yup.string().when('shipment_type', {
            is: (value: string) => !['INLAND'].includes(value),
            then: Yup.string().nullable().required(requiredFieldMessage),
            otherwise: Yup.string().nullable()
        }),
        origin_country: Yup.string().required(requiredFieldMessage),
        destination: Yup.string().when('shipment_type', {
            is: (value: string) => !['INLAND'].includes(value),
            then: Yup.string().nullable().required(requiredFieldMessage),
            otherwise: Yup.string().nullable()
        }),
        destination_country: Yup.string().required(requiredFieldMessage),
        incoterms: Yup.string().when('shipment_type', {
            is: (value: string) => !['INLAND'].includes(value),
            then: Yup.string().nullable().required(requiredFieldMessage),
            otherwise: Yup.string().nullable()
        }),
        sub_type: Yup.string().when('shipment_type', {
            is: (value: string) => ['OI', 'OEX', 'OE', 'DROP_OCEAN', 'INLAND'].includes(value),
            then: Yup.string().required(requiredFieldMessage).nullable(),
            otherwise: Yup.string().nullable()
        }),
        destination_pickup_address: Yup.string().nullable().test('len', 'Max 150 characters', maxLengthValidation(150)),
        origin_pickup_address: Yup.string().nullable().test('len', 'Max 150 characters', maxLengthValidation(150)),
        destination_zipcode: Yup.string()
            .when('shipment_type', {
                is: (value: string) => ['INLAND', 'RAIL'].includes(value),
                then: Yup.string().required(requiredFieldMessage).nullable(),
                otherwise: Yup.string().nullable()
            })
            .test('len', 'Max 200 characters', maxLengthValidation(200)),
        origin_zipcode: Yup.string()
            .when('shipment_type', {
                is: (value: string) => ['INLAND', 'RAIL'].includes(value),
                then: Yup.string().required(requiredFieldMessage).nullable(),
                otherwise: Yup.string().nullable()
            })
            .test('len', 'Max 200 characters', maxLengthValidation(200)),
        goods_ready: Yup.date().when(['shipment_type', 'sub_type'], {
            is: (type: string, sub_type: string) => ['OI'].includes(type) && sub_type === 'FCL',
            then: Yup.date().required(requiredFieldMessage).nullable(),
            otherwise: Yup.date().nullable()
        }),
        eta: Yup.date()
            .when('etd', (st: string, schema: any) => {
                if (st) {
                    return schema.min(new Date(st), dateAfterMessage(moment(st).format('DD/MM/YYYY HH:mm')));
                }

                return;
            })
            .nullable(),
        weight: Yup.number().when(['shipment_type', 'isTotals'], {
            is: (shipment_type: string, isTotals: boolean) => shipment_type === 'EXPRESS' && isTotals,
            then: Yup.number().required(requiredFieldMessage).min(0.001, 'Weight must be greater than 0'),
            otherwise: Yup.number().nullable()
        }),
        weightUnit: Yup.string().when(['shipment_type', 'isTotals'], {
            is: (shipment_type: string, isTotals: boolean) => shipment_type === 'EXPRESS' && isTotals,
            then: Yup.string().required(requiredFieldMessage),
            otherwise: Yup.string().nullable()
        }),
        quantity: Yup.number()
            .when('sub_type', {
                is: (sub_type: string) => sub_type === 'FCL',
                then: Yup.number().nullable(),
                otherwise: Yup.number().required(requiredFieldMessage).min(0.001, 'Quantity must be greater than 0')
            }),
        master: Yup.string()
            .when('shipment_type', {
                is: (value: string) => !['EXPRESS', 'INLAND'].includes(value),
                then: Yup.string()
                    .nullable()
                    .test('no-special-chars', 'Master can only contain letters, numbers, and hyphens', (val) => !val || /^[a-zA-Z0-9\-]*$/.test(val)),
                otherwise: Yup.string().nullable()
            }),
        house: Yup.string()
            .nullable()
            .test('no-special-chars', 'House can only contain letters, numbers, and hyphens', (val) => !val || /^[a-zA-Z0-9\-]*$/.test(val)),
        mawb_type: Yup.string()
            .when('shipment_type', {
                is: 'EXPRESS',
                then: Yup.string().required('MAWB Type is required for Express shipments').oneOf(['AG'], 'Only AG is allowed for Express shipments'),
                otherwise: Yup.string()
                    .when(['shipment_type', 'sub_type'], {
                        is: (shipment_type: string, sub_type: string) => {
                            // Air segments (AI, AE, DROP_AIR) - AG only
                            if (['AI', 'AE', 'DROP_AIR'].includes(shipment_type)) {
                                return true;
                            }
                            // SEA LCL (OI, OE, OEX, DROP_OCEAN with LCL) - DL + GL + GU
                            if (['OI', 'OE', 'OEX', 'DROP_OCEAN'].includes(shipment_type) && sub_type === 'LCL') {
                                return true;
                            }
                            // SEA FCL (OI, OE, OEX, DROP_OCEAN with FCL) - DF + GF
                            if (['OI', 'OE', 'OEX', 'DROP_OCEAN'].includes(shipment_type) && sub_type === 'FCL') {
                                return true;
                            }
                            return false;
                        },
                        then: Yup.string()
                            // Removed .required() to make optional during creation, but keep format validation
                            .test('valid-master-type', 'Invalid Master Type for this segment', function(value) {
                                const { shipment_type, sub_type } = this.parent;
                                // Allow null/empty during creation, but validate format if provided
                                if (!value) return true;

                                // Air segments - only AG allowed
                                if (['AI', 'AE', 'DROP_AIR'].includes(shipment_type)) {
                                    return value === 'AG';
                                }
                                // SEA LCL - only DL, GL, GU allowed
                                if (['OI', 'OE', 'OEX', 'DROP_OCEAN'].includes(shipment_type) && sub_type === 'LCL') {
                                    return ['DL', 'GL', 'GU'].includes(value);
                                }
                                // SEA FCL - only DF and GF allowed
                                if (['OI', 'OE', 'OEX', 'DROP_OCEAN'].includes(shipment_type) && sub_type === 'FCL') {
                                    return ['DF', 'GF'].includes(value);
                                }
                                return false;
                            })
                            .nullable(),
                        otherwise: Yup.string().nullable().oneOf(['GF', 'GL', 'GU', 'AG', 'DF', 'DL', null], 'Invalid Master Type')
                    })
            }),
        declaration_number: Yup.string().nullable().test('len', 'Max 255 characters', maxLengthValidation(255)),
        storage_site_code: Yup.string().nullable().test('len', 'Max 50 characters', maxLengthValidation(50)),
        storage_site_name: Yup.string().nullable().test('len', 'Max 255 characters', maxLengthValidation(255)),
        handling_agent: Yup.string().nullable(),
        co_loader: Yup.string().nullable(),
        assigned_to: Yup.string().required(requiredFieldMessage)
    });
};

const maxLengthValidation = (maxLength: number) => {
    return (val: any) => (val ? val.toString().length <= maxLength : true);
};